export const UPDATE_SEARCH_ID = 'SEARCHES/UPDATE_SEARCH_ID';
export const UPDATE_SIMILAR_CANDIDATES_SEARCH_ID_IN_PROFILE =
  'SEARCHES/UPDATE_SIMILAR_CANDIDATES_SEARCH_ID_IN_PROFILE';
export const UPDATE_ACTIVE_SIMILAR_CANDIDATES_ID =
  'SEARCHES/UPDATE_ACTIVE_SIMILAR_CANDIDATES_ID';
